import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { formatInr } from '../lib/formatInr';

// Shows why the last refund attempt failed or only partly went through.
export const RefundErrorNote = ({ booking, testId }) => {
  const e = booking?.last_refund_error;
  if (!e || !e.message) return null;
  const when = e.at ? new Date(e.at).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' }) : '';
  return (
    <div data-testid={testId} className="mt-2 p-2 border-2 border-red-700 bg-red-50 text-red-700 text-[11px] font-mono flex items-start gap-2">
      <AlertTriangle size={12} className="mt-0.5 shrink-0" />
      <div>
        <div className="font-bold">
          Last refund {Number(e.refunded) > 0 ? `only partly went through: ${formatInr(e.refunded)} of ${formatInr(e.requested)}` : `of ${formatInr(e.requested)} failed`}{when ? ` (${when})` : ''}
        </div>
        <div>{e.message}</div>
      </div>
    </div>
  );
};
